<script>
  import { format } from 'svelte-i18n';
  import { Badge, Spinner, Tooltip } from '@sveltestrap/sveltestrap';
  import { v4 as uuidv4 } from 'uuid';

  export let error = false;
  export let success = false;
  export let tooltip;

  export let props = {};
  export let row = {};

  const id = `row-status-${uuidv4()}`;

  $: error = props.error(row);
  $: success = props.success(row);
  $: tooltip = props.tooltip(row);
</script>

{#if error}
  <Badge {id} color="danger">
    {$format('label.FAILURE.PUSH_STATUS')}
  </Badge>
  {#if tooltip}
    <Tooltip placement="right" target={id}>
      {tooltip}
    </Tooltip>
  {/if}
{:else if success}
  <Badge {id} color="success">
    {$format('label.SUCCESS.PUSH_STATUS')}
  </Badge>
{:else}
  <Spinner color="primary" size="sm" />
{/if}
